<template>
    <div>
        <multiselect
            v-model="values"
            :options="filteredCentreOptions"
            :multiple="true"
            group-values="centres"
            group-label="country"
            :group-select="true"
            placeholder="Type to search"
            track-by="id"
            label="name"
            :internal-search="false"
            @search-change="searchCentre"
        />

        <input type="hidden" name="user_centres[]" :value="value.id" v-bind:key="value.id" v-for="value in values" />

    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
    name: "CentreSelectComponent",
    components: {
        Multiselect
    },
    props: {
        centresToAssign: {
            type: [Object, Array],
            required: true,
        },
        userCentres: {
            type: [Object, Array],
            required: true,
        }
    },
    data: () => {
        return {
            options: [],
            values: [],
            filterText: '',
            value: [],
        }
    },
    mounted() {
        this.setUpOptions();

        this.setUpValues();
    },
    computed: {
        filteredCentreOptions() {
            return this.options.map(country =>
                ({
                    ...country, centres:
                        country.centres.filter(c => c.searchValue.toLowerCase().includes(this.filterText.toLowerCase()))
                }))
        }
    },
    methods: {
        searchCentre (filterText) {
            this.filterText = filterText;
        },

        setUpOptions: function() {
            this.options = Object.entries(this.centresToAssign).map((val) => {
                return {
                    country: val[0],
                    centres: Object.values(val[1]).map((centreVal) => {
                        return {
                            id: centreVal.id,
                            name: centreVal.name,
                            searchValue: val[0] +  ' ' + centreVal.name
                        }
                    }),
                };
            });

        },

        setUpValues: function() {
            let mapped = this.options.flatMap((option)  => {
                return option.centres;
            })

            let userCentres = this.userCentres.map((centreId) => parseInt(centreId))

            this.values = mapped.filter((centre) => {
                return userCentres.includes(centre.id);
            });
        },

    }
}
</script>

<style scoped>
.multiselect, .multiselect__input, .multiselect__single {
    font-size: 14px!important;
}

.multiselect__option {
    min-height: 14px!important;
}

.multiselect__option:after {
    line-height: 14px!important;
}
</style>
